export const ORDINARY = "ORDINARY";
export const TURBO = "TURBO";
export const TURBO_PLUS = "TURBO_PLUS";